export const invertedScores = [
  "sift",
  "sift4g",
  "provean",
  "fathmm",
  "lrt",
  "blosum",
];
/*  getThresholds function returns an object for the thresholds of the specified database
    thresholds input is an array of objetcs */

export const getThresholds = (prefix, thresholds) => {
  if (!thresholds || thresholds?.length === 0 || !Array.isArray(thresholds))
    return {};
  // eslint-disable-next-line array-callback-return
  const insilicoThreshold = thresholds?.find(
    ({ name }) => name.toLocaleLowerCase().replace("-", "_") === prefix
  );
  if (!insilicoThreshold) return {};

  const inverted = invertedScores?.includes(
    insilicoThreshold?.name?.toLocaleLowerCase()?.replace("-", "_")
  );

  const {
    benign_supporting: { threshold: benignThresholdSupporting },
    benign_moderate: { threshold: benignThresholdModerate },
    benign_strong: { threshold: benignThresholdStrong },
    benign_very_strong: { threshold: benignThresholdVeryStong },
    pathogenic_supporting: { threshold: pathogenicThresholdSupporting },
    pathogenic_moderate: { threshold: pathogenicThresholdModerate },
    pathogenic_strong: { threshold: pathogenicThresholdStrong },
    pathogenic_very_strong: { threshold: pathogenicThresholdVeryStrong },
    benign_supporting: { threshold: benignThreshold },
    pathogenic_supporting: { threshold: pathogenicThreshold },
  } = insilicoThreshold;

  return {
    benignThresholdSupporting,
    benignThresholdModerate,
    benignThresholdStrong,
    benignThresholdVeryStong,
    pathogenicThresholdSupporting,
    pathogenicThresholdModerate,
    pathogenicThresholdStrong,
    isInverted: inverted,
    pathogenicThresholdVeryStrong,
    benignThreshold,
    pathogenicThreshold,
  };
};
